import * as moment from "moment";

export class AnexosEtapa2ResponseDTO {
  dimensaoProjeto: string[];
  nomeArquivo: string;
  comentario: string;
  dataUpload: any;
  arquivo?: ArquivoEtapa2ResponseDTO;
  tipoDocumento: string;

  constructor(obj: any) {
    if (obj) {
      this.dimensaoProjeto = obj.dimensaoProjeto;
      this.nomeArquivo = obj.nomeArquivo;
      this.comentario = obj.comentario;
      this.dataUpload = obj.dataUpload ? this.parseDataUpload(obj.dataUpload) : null;
      this.arquivo = new ArquivoEtapa2ResponseDTO(obj.arquivo);
      this.tipoDocumento = obj.tipoDocumento;
    }
  }

  private parseDataUpload(dataUpload: string): Date {
    return moment.parseZone(dataUpload, 'DD-MM-YYYY HH:mm').toDate();
  }
}

export class ArquivoEtapa2ResponseDTO {
  id: string;
  nome: string;
  base64: string;
  extensao: string;
  acao: string;

  constructor(obj: any) {
    if (obj) {
      this.id = obj.id;
      this.nome = obj.nome;
      this.base64 = obj.base64;
      this.extensao = obj.extensao;
      this.acao = obj.acao;
    }
  }
}
